class Form {
  static init() {
    this.labelAnimation();
    this.addEventTracking();
    this.checksomethings();
  }

  static labelAnimation() {
    let inputWrappers = document.querySelectorAll('.input-wrapper');
    if (inputWrappers.length == 0)
      return;

    inputWrappers.forEach((el) => {
      let input = el.querySelector('.form-control');
      if (input) {
        input.addEventListener('focusin', () => {
          el.classList.add('active');
        });
        input.addEventListener('focusout', () => {
          if (input.value == '')
            el.classList.remove('active');
        })
      }
    });
  }

  static addEventTracking() {
    var wpcf7Elm = document.querySelector('.wpcf7');

    wpcf7Elm.addEventListener(
      'wpcf7mailsent',
      function (event) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'form_submitted',
          formType: 'Formulaire de contact',
        });
      },
      false
    );
  }

  static checksomethings() {
    var wpcf7Elm = document.querySelector('.wpcf7-form');
    wpcf7Elm?.addEventListener('submit', function(event) {
      const formData = new FormData(event.target);
      console.log(formData.get('heure'));
    })
  }
}

export default Form;
